/* Product page: size buttons, sliding gallery, AJAX add-to-cart.
   - Size is chosen with large buttons; changing it swaps the design image
     (slide 0 + design thumbnail) and updates price + the cart line.
   - The gallery is a horizontal slider (arrows + thumbs + swipe, wraps
     around) showing the selected size's design plus the mockup(s).
   - Add to cart posts via the AJAX Cart API and opens the cart drawer —
     no page reload, CTA reachable from the sticky mobile bar too. */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function init(root) {
    if (!root || root.dataset.productInit) return;
    root.dataset.productInit = '1';

    var mainImg = root.querySelector('[data-main-image]');
    var designThumbBtn = root.querySelector('[data-thumb][data-role="design"]');
    var designThumbImg = root.querySelector('[data-design-thumb]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));

    /* ---- gallery slider ---- */
    /* Slides and thumbs share the same order (design first, then mockups),
       so slide i pairs with thumb i. The track slides horizontally; arrows,
       thumbs and swipe all drive the same index (wraps around). */
    var track = root.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var prevBtn = root.querySelector('[data-gallery-prev]');
    var nextBtn = root.querySelector('[data-gallery-next]');
    var stage = root.querySelector('[data-gallery-stage]');
    var index = 0;

    function activateThumb(i) {
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
    }

    function goTo(i) {
      if (slides.length === 0) return;
      index = (i + slides.length) % slides.length;
      if (track) track.style.transform = 'translateX(' + (-index * 100) + '%)';
      activateThumb(index);
    }

    if (slides.length > 1) {
      if (prevBtn) {
        prevBtn.hidden = false;
        prevBtn.addEventListener('click', function () { goTo(index - 1); });
      }
      if (nextBtn) {
        nextBtn.hidden = false;
        nextBtn.addEventListener('click', function () { goTo(index + 1); });
      }

      /* swipe on touch devices */
      var startX = null;
      if (stage) {
        stage.addEventListener('touchstart', function (e) {
          startX = e.touches[0].clientX;
        }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (startX === null) return;
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) goTo(index + (dx < 0 ? 1 : -1));
          startX = null;
        }, { passive: true });
      }
    }

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { goTo(i); });
    });

    /* ---- variant state ---- */
    var variantsEl = root.querySelector('[data-product-variants]');
    var idInput = root.querySelector('[data-valismo-variant-id]');
    var priceEl = root.querySelector('[data-price-value]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var submit = root.querySelector('[data-product-submit]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-group]'));

    var variants = [];
    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }
    }

    var addLabel = submit ? submit.textContent.trim() : 'In den Warenkorb';

    function chosenOptions() {
      return groups.map(function (g) {
        var active = g.querySelector('.valismo-size-btn.is-active');
        return active ? active.dataset.optionValue : null;
      });
    }

    function matchVariant() {
      if (groups.length === 0) return variants[0];
      var chosen = chosenOptions();
      return variants.find(function (v) {
        return v.options.length === chosen.length &&
          v.options.every(function (o, i) { return o === chosen[i]; });
      });
    }

    function setAvailability(available) {
      [submit, stickyAdd].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
        btn.textContent = available ? addLabel : 'Ausverkauft';
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;

      /* swap the design image (slide 0 + its thumb) to this size */
      if (variant.image) {
        if (designThumbBtn) designThumbBtn.dataset.full = variant.image;
        if (designThumbImg && variant.imageThumb) designThumbImg.src = variant.imageThumb;
        if (mainImg) mainImg.src = variant.image;
      }

      if (priceEl && variant.priceFormatted) priceEl.textContent = variant.priceFormatted;
      if (stickyPrice && variant.priceFormatted) stickyPrice.textContent = variant.priceFormatted;
      setAvailability(variant.available);
    }

    groups.forEach(function (g) {
      g.querySelectorAll('.valismo-size-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          g.querySelectorAll('.valismo-size-btn').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          /* selecting a size focuses the design image (slide 0) */
          goTo(0);
          applyVariant(matchVariant());
        });
      });
    });

    /* ---- add to cart ---- */
    var form = root.querySelector('.valismo-product__form');

    function addToCart() {
      if (!idInput || !idInput.value) return;
      [submit, stickyAdd].forEach(function (b) { if (b) b.classList.add('is-busy'); });

      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(idInput.value), quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function (item) {
          document.dispatchEvent(new CustomEvent('valismo:cart:added', { detail: item }));
          document.dispatchEvent(new CustomEvent('valismo:cart:open'));
          if (submit) {
            submit.classList.add('is-added');
            submit.textContent = 'Hinzugefügt ✓';
            setTimeout(function () {
              submit.classList.remove('is-added');
              submit.textContent = addLabel;
            }, 1600);
          }
        })
        .catch(function () {
          if (form) form.submit(); /* fallback to a full page cart add */
        })
        .then(function () {
          [submit, stickyAdd].forEach(function (b) { if (b) b.classList.remove('is-busy'); });
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart();
      });
    }
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        if (!stickyAdd.disabled) addToCart();
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-product-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-product-section]');
    if (root) init(root);
  });
})();
